<div class="flex flex-col -m-6">

  <!-- Header -->
  <div class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
    <div class="text-lg font-medium">{{ 'selectAddress' | transloco }}</div>
    <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
      <mat-icon class="text-current" [svgIcon]="'mat_outline:close'"></mat-icon>
    </button>
  </div>

  <!-- Content -->
  <div class="flex flex-col p-2 sm:p-8 w-full">
    <!-- Address list -->
    <div class="relative">
      @for (address of data.addressList; track trackByFn(i, address); let i = $index) {
        <!-- Address -->
        <a class="z-20 flex items-center px-6 py-4 md:px-8 cursor-pointer border-b" (click)="selected = address"
                    [ngClass]="{'hover:bg-gray-100 dark:hover:bg-hover': !selected || selected.placeId !== address.placeId,
                                'bg-primary-50 dark:bg-hover': selected && selected.placeId === address.placeId}">
          <div class="flex flex-0 items-center justify-center w-10 h-10 rounded-full overflow-hidden">
            <!-- <ng-container *ngIf="address.type">
            <mat-icon class="icon-size-8" [svgIcon]="getIcon(address.type)"></mat-icon>
          </ng-container> -->
        </div>
        <div class="min-w-0 ml-4">
          <div class="font-medium leading-5 truncate">{{ address.name }}</div>
          <div class="leading-5 truncate text-secondary">{{ address.vicinity }}</div>
        </div>
      </a>
    }

  </div>
</div>

<!-- Actions -->
<div class="flex flex-row justify-end px-4 pb-2 sm:px-8 sm:pb-8 w-full">
  <button mat-raised-button (click)="save()" [disabled]="!selected">
    {{ 'save' | transloco }}
  </button>
</div>
</div>